/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum FeatureFlag {
    QUICKSIGHT_AUTHORING_ENABLED = 'quicksight_authoring_enabled',
    DATA_MANAGEMENT = 'data_management',
    DATA_MANAGEMENT_V2 = 'data_management_v2',
    TENANCY_MANAGEMENT = 'tenancy_management',
    BETTER_AGENTS = 'better_agents',
    MAX_ALLOWED_CUTS_SELECTION = 'max_allowed_cuts_selection',
    PAY_TYPE_GRADE_ENABLED = 'pay_type_grade_enabled',
    AI_CHAT = 'ai_chat',
    ETL_ASSETS_ENABLED = 'etl_assets_enabled',
    SURVEY_SEASON_WORKFLOW = 'survey_season_workflow',
    SURVEY_SEASON_WORKFLOW_ACTIVATE_PLAN = 'survey_season_workflow_activate_plan',
    RANGE_BUILDER_CURRENCY = 'range_builder_currency',
    RANGE_VISUALS_JOBS = 'range_visuals_jobs',
    REFINED_GET_SURVEY_DATA_BY_POLICY_ENABLED = 'refined_get_survey_data_by_policy_enabled',
    SURVEY_SEASON_WORKFLOW_ENABLE_SURVEYS = 'survey_season_workflow_enable_surveys',
    HRIS_DATA_MANAGEMENT = 'hris_data_management',
    COMPOSITES_TABLE_REVAMP = 'composites_table_revamp',
    ASK_BETTERCOMP_SURVEY_DATA = 'ask_bettercomp_survey_data',
    IN_APP_SUPPORT_REQUEST = 'in_app_support_request',
    AMS_SPA_AUTH_ENABLED = 'ams_spa_auth_enabled',
    SURVEY_SEASON_REVIEW_STEP_CUT_AVAILABILITY = 'survey_season_review_step_cut_availability',
}
